// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.progress-circle-container {
  position: relative;
}
.progress-circle-container .circle-checkmark {
  position: absolute;
  top: 50%;
  right: 50%;
  transform: translate(50%, -50%);
}`, "",{"version":3,"sources":["webpack://./src/app/core/modules/shared/components/progress-loader/progress-loader.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;AACE;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,+BAAA;AACJ","sourcesContent":[".progress-circle-container {\n  position: relative;\n\n  .circle-checkmark {\n    position: absolute;\n    top: 50%;\n    right: 50%;\n    transform: translate(50%, -50%);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
